import * as rtApi from '../components/Api';

const Validate = {
  Url: (url) => {
    // console.log('validate url', url);
    const re = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    return re.test(String(url).toLowerCase());
  },
  Email: (email) => {
    // console.log('validate email', email);
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  Password: (password) => {
    // console.log('validate password', password);
    return password && String(password).length >= 15;
  },
  Name: (name) => {
    // console.log('validate name', name);
    return name && String(name).length >= 1;
  },
  Blank: (text) => {
    // console.log('validate blank', text);
    return text && String(text).length >= 1;
  },
  PhoneNumber: (phoneNumber) => {
    // console.log('validate phone number', phoneNumber);
    return phoneNumber && phoneNumber.length >= 13
  },
  isExistingEmail: (emailAddress) => {
    // console.log('isExistingEmail', emailAddress);
    return rtApi.get(`search/email&email_address=${emailAddress}`)
    .then(data => {
      return { result: true, isExisting: data };
    }).catch(err => {
      console.log(err);
      return { result: false, error: err.statusText || 'An unknown error occured' };
    });
  },
  Amount: (val) => {
    if(val === ''){ return false; }
    // console.log('validate amount', val);
    val = parseFloat(val.replace(/[^0-9.]/g, ''));
    return val >= 0.01;
  },
  CardNumber: (val) => {
    if (val === '') { return false; }
    return val && String(val).length >= 9 && String(val).length <= 11;
  },
  CardExpiry: (val) => {
    if(val === ''){ return false; }
    let e = val.split('/');
    if(e.length !== 2){
      return false;
    }
    let month = parseInt(e[0]);
    let year = parseInt(e[1]);
    if(month >= 1 && month <= 12 && year >= 21 && year <= 99){
      return true;
    }
    return false;
  },
  CardCvv: (val) => {
    if (val === '') { return false; }
    return val && (String(val).length === 3 || String(val).length === 4);
  },
  BusinessNumber: (text) => {
    // console.log('validate blank', text);
    return text && String(text).length === 9;
  },
};

export default Validate;